import type { SavePayload } from "../../hooks/bookingTypes";
import type { Channel } from "../shared";

/** Поля формы, из которых собирается тело сохранения брони (вынос из
 *  BookingModal.handleSave, 15.08 — файл упёрся в базлайн). */
export interface SaveFields {
  id?: number;
  questId: string;
  slotTime: string;
  customTime: string;
  formType: string;
  players: string;
  clientName: string;
  phone: string;
  prepaid: boolean;
  prepaidAmt: number;
  tea: boolean;
  teaRoomId: string | null;
  teaMinCfg: number;
  extras: string[];
  tg: string;
  comment: string;
  userId: string;
  source: string;
  isClass: boolean;
  isBirthday: boolean;
  isLearning: boolean;
  /** 13.10: кто из сотрудников играет; undefined — состав ещё не загружен (не трогаем серверный). */
  learningPlayers?: string[];
  isCompetition: boolean;
  isSpecialEvent: boolean;
  specialVersionId: string;
  isPriority: boolean;
  channel: Channel;
  overrideDateStr: string;
  isBlock?: boolean;
}

/** camelCase-поля + snake_case-дубли для бэка — 1:1 прежний литерал handleSave. */
export function buildSavePayload(f: SaveFields): SavePayload & Record<string, unknown> {
  /* 28.09: у блока «Сохранить» правит только причину (BlockForm). Раньше уходила форма брони
     с type='lead' — блок молча становился пустой заявкой (сервер теперь отсекает и сам). */
  if (f.isBlock) {
    const reason = f.comment.replace(/^БЛОК · /, "").trim();
    return { id: f.id, questId: f.questId, time: f.slotTime, ...(reason ? { block_reason: reason } : {}) } as unknown as SavePayload & Record<string, unknown>;
  }
  return {
    id: f.id,
    questId: f.questId,
    time: f.customTime || f.slotTime,
    type: f.formType,
    players: parseInt(f.players) || 0,
    clientName: f.clientName,
    phone: f.phone,
    prepaid: f.prepaid,
    prepaidAmount: f.prepaid ? f.prepaidAmt : 0,
    tea: f.tea,
    teaRoomId: f.tea ? f.teaRoomId || null : null,
    teaMin: f.tea ? f.teaMinCfg : 0,
    mc: f.extras.length ? f.extras.join(",") : "none",
    tg: f.tg,
    comment: f.comment,
    dkUser: f.userId,
    source: f.source,
    isClass: f.isClass,
    isBirthday: f.isBirthday,
    isLearning: f.isLearning,
    isCompetition: f.isCompetition,
    isSpecialEvent: f.isSpecialEvent,
    isPriority: f.isPriority,
    channel: f.channel,
    customTime: f.customTime || null,
    overrideDate: f.overrideDateStr || null,
    // snake_case duplicates for backend body
    client_name: f.clientName,
    tea_room_id: f.tea ? f.teaRoomId || null : null,
    tea_minutes: f.tea ? f.teaMinCfg : 0,
    prepaid_amount: f.prepaid ? f.prepaidAmt : 0,
    dc_user_id: f.userId,
    is_class: f.isClass ? 1 : 0,
    is_birthday: f.isBirthday ? 1 : 0,
    is_learning: f.isLearning ? 1 : 0,
    is_competition: f.isCompetition ? 1 : 0,
    is_special_event: f.isSpecialEvent ? 1 : 0,
    special_version_id: f.isSpecialEvent ? f.specialVersionId : "",
    is_priority: f.isPriority ? 1 : 0,
    custom_time: f.customTime || null,
    /* 13.10: состав учебной игры — только когда он загружен и «Учеб» включён (снятый флаг is_learning=0
       сервер сам очищает; без поля сервер состав не трогает — ранний «Сохранить» его не затрёт). */
    ...(f.isLearning && f.learningPlayers ? { learningPlayers: f.learningPlayers, learning_players: f.learningPlayers } : {}),
  };
}
